import React, {useState, useEffect} from "react";

function HighscoresBoard({handleHighscoreBoard, highscoresData, highscoresNote}){
  const [note, setNote] = useState("");
 function handleHighscoreBoardClick() {
    handleHighscoreBoard();
  }
  useEffect(() => {
    setNote(highscoresNote);
  }, [highscoresNote]);
  function formatTime(time){
      const totalMilliseconds = Math.floor(time);
      const hours = Math.floor(totalMilliseconds / 3600000);
      const minutes = Math.floor((totalMilliseconds % 3600000) / 60000);
      const seconds = Math.floor((totalMilliseconds % 60000) / 1000);
      const milliseconds = totalMilliseconds % 1000;
      const stringTime = `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}:${milliseconds.toString().padStart(2,"0")}`;

      return stringTime;

  }
  //  let highscores = [{name:"John", time: 22, moves: 44}, {name:"Jeff", time: 23, moves: 66}, {name: "Peter", time: 50, moves: 88}]
    return (
      <div
        className="highscoresBoard"
        id="highscoresBoard"
        onClick={handleHighscoreBoard}
      >
        <h3>Highscores Board</h3>
        <p className="bestEver">
          <i>All time high scores</i>
        </p>
        <div className="highscoresTableDiv">
          <table className="highscoresTable">
            <thead>
              <th className="highscoresRank">RANK</th>
              <th className="highscoresNAME">NAME</th>
              <th className="highscoresTIME">TIME</th>
              <th className="highscoresMOVES">MOVES</th>
            </thead>
            <tbody>
              {highscoresData.map((winner, index) => (
                <tr key={`row + ${index}`}>
                  <td className="highscoresRowRank" key={`rank + ${index}`}>
                    <b>{index + 1}</b>
                  </td>
                  <td
                    className="highscoresRowName"
                    key={`player_name + ${index}`}
                  >
                    {winner.player_name}
                  </td>
                  <td
                    className="highscoresRowTime"
                    key={`time_taken + ${index}`}
                  >
                    {formatTime(winner.time_taken)}
                  </td>
                  <td className="highscoresRowMoves" key={`moves + ${index}`}>
                    {winner.moves}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          ..{note}.
        </div>
      </div>
    );
}

export default HighscoresBoard; 